export default __webpack_public_path__ + "static/Leo-022322bd0eca40309b372a67989b0d8c7b9566437f045c0c68b51c03a31205f9.svg";